<template>
    <div class="scc-prize-teaser" :class="`scc-prize-teaser--margin-${margin} scc-prize-teaser--label-${labelColor}`">
        <div class="scc-prize-teaser__image-container">
            <div class="scc-prize-teaser__quantity-outer-container">
                <div class="scc-prize-teaser__quantity-container">
                    <div class="scc-prize-teaser__quantity h5">{{ label }}</div>
                </div>
            </div>
            <div class="scc-prize-teaser__image" :style="[backgroundImage]">
                <p class="scc-prize-teaser__text h4">{{ text }}</p>
                <SccLink class="scc-prize-teaser__button" button color="secondary" to="prijzen">
                    {{ buttonText }}
                </SccLink>
            </div>
        </div>
    </div>
</template>

<script>
import './prize-teaser.scss';
import SccLink from '../global/SccLink';

export default {
    name: 'PrizeTeaser',
    components: { SccLink },
    __editor: {
        fields: {
            image: {
                widget: 'media',
            },
            labelColor: {
                widget: 'select',
                values: ['primary', 'secondary', 'white'],
            },
            text: {
                widget: 'textarea',
            },
            margin: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large'],
            },
        },
    },
    props: {
        image: {
            type: String,
            default: null,
        },
        label: {
            type: String,
            default: '',
        },
        labelColor: {
            type: String,
            required: false,
            default: 'white',
            validator: function(val) {
                return ['primary', 'secondary', 'white'].includes(val);
            },
        },
        text: {
            type: String,
            default: '',
        },
        buttonText: {
            type: String,
            default: '',
        },
        margin: {
            type: String,
            required: false,
            default: 'medium',
        },
    },
    computed: {
        backgroundImage() {
            if (this.image)
                return {
                    backgroundImage: `url(${this.image})`,
                    backgroundSize: 'cover',
                    backgroundPosition: 'center',
                };
            else return false;
        },
    },
};
</script>
